.page {
  padding: 32px 32px 64px;
  max-width: 1200px;
  margin: 0 auto;
}

.header {
  margin-bottom: 24px;
}

.title {
  font-size: 28px;
  font-weight: 700;
  margin: 0;
  color: #fff;
  letter-spacing: var(--kh-ls-heading);
}

.subtitle {
  margin: 6px 0 0;
  color: rgba(255, 255, 255, 0.85);
  font-size: var(--kh-size-body);
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 20px;
  background: var(--kh-surface);
  border-radius: var(--kh-radius-card);
  box-shadow: var(--kh-shadow-1);
  text-decoration: none;
  color: var(--kh-text-primary);
  transition:
    transform var(--kh-duration-fast) var(--kh-ease-out),
    box-shadow var(--kh-duration-fast) var(--kh-ease-out);
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: var(--kh-shadow-2);
}

.cardName {
  font-size: 16px;
  font-weight: 700;
}

.cardDomain {
  font-size: var(--kh-size-meta);
  color: var(--kh-text-secondary);
}

.cardId {
  margin-top: 8px;
  font-size: var(--kh-size-meta);
  color: var(--kh-text-muted);
  font-family: var(--kh-font-mono);
}

.empty {
  padding: 48px;
  text-align: center;
  color: rgba(255, 255, 255, 0.85);
  background: rgba(255, 255, 255, 0.06);
  border-radius: var(--kh-radius-card);
}
